import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import _jsx from '@babel/runtime/helpers/jsx';
import classNames from 'classnames';
import { VisuallyHidden } from '@andes/common';
import Button from '@andes/button';
const namespace = 'andes-snackbar';
const computeTypeColor = _ref => {
  let {
    type,
    color
  } = _ref;
  if (color) return color;
  switch (type) {
    case 'error':
      return 'red';
    case 'success':
      return 'green';
    default:
      return undefined;
  }
};
var computeTypeColor$1 = computeTypeColor;
const computeActionProps = _ref => {
  let {
    action: actionProp,
    actionMessage: actionMessageProp,
    onActionClick: onActionClickProp,
    actionPosition: actionPositionProp
  } = _ref;
  const {
    onClick,
    text,
    position
  } = actionProp || {};
  const actionConfig = {
    onClick: onClick || onActionClickProp,
    text: text || actionMessageProp,
    position: position || actionPositionProp || 'right'
  };
  return actionConfig;
};
var computeAction = computeActionProps;
class Snackbar extends React.Component {
  constructor(props) {
    super(props);
    const {
      show = false
    } = this.props;
    this.onActionClick = this.onActionClick.bind(this);
    this.onAnimationEnd = this.onAnimationEnd.bind(this);
    this.setMainContainerRef = this.setMainContainerRef.bind(this);
    this.state = {
      display: show,
      show,
      srLabelVisibility: false
    };
    this.style = {};
  }
  componentDidMount() {
    const {
      show = false,
      delay,
      onChange,
      onClose,
      onOpen
    } = this.props;
    const fixedElement = document.querySelector('.andes-snackbar-fixed-element');
    if (fixedElement) {
      this.style = {
        bottom: "".concat(fixedElement.offsetHeight + 16, "px")
      };
    }
    if (show && delay) {
      this.delayTimeout = setTimeout(() => {
        this.setState({
          show: false
        }, () => {
          if (typeof onChange === 'function') onChange(false);
          if (typeof onClose === 'function') onClose();
        });
      }, delay);
    }
    this.labelTimeout = setTimeout(() => {
      this.setState({
        srLabelVisibility: true
      });
    }, 30);
    if (show && typeof onOpen === 'function') {
      onOpen();
    }
  }
  componentWillUnmount() {
    const {
      onClose
    } = this.props;
    clearTimeout(this.delayTimeout);
    clearTimeout(this.labelTimeout);
    if (typeof onClose === 'function') {
      onClose();
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      show = false
    } = this.props;
    const {
      show: stateShow
    } = this.state;
    const hasDelayProps = nextProps.delay;
    const startedShowing = !show && nextProps.show;
    const showPropChanged = show !== nextProps.show;
    const nextShowPropDiffersFromState = nextProps.show !== stateShow;
    if (showPropChanged && nextShowPropDiffersFromState) {
      this.setState({
        display: nextProps.show || false,
        show: nextProps.show || false
      }, () => {
        if (nextProps.onChange) nextProps.onChange(nextProps.show || false);
        if (nextProps.show && nextProps.onOpen) {
          nextProps.onOpen();
        } else if (!nextProps.show && nextProps.onClose) {
          nextProps.onClose();
        }
      });
    }
    if (startedShowing && hasDelayProps) {
      this.delayTimeout = setTimeout(() => {
        this.setState({
          show: false
        }, () => {
          if (nextProps.onChange) nextProps.onChange(false);
          if (nextProps.onClose) nextProps.onClose();
        });
      }, nextProps.delay);
    }
    if (!nextProps.show) {
      clearTimeout(this.delayTimeout);
    }
  }
  onActionClick(event, onClickProp) {
    if (typeof onClickProp === 'function') {
      clearTimeout(this.delayTimeout);
      onClickProp(event);
    }
  }
  onAnimationEnd() {
    const {
      show
    } = this.state;
    if (!show) {
      this.setState({
        display: false
      });
      clearTimeout(this.delayTimeout);
    }
  }
  setMainContainerRef(ref) {
    const {
      innerRef
    } = this.props;
    if (innerRef) {
      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else {
        innerRef.current = ref;
      }
    }
  }
  renderAction(_ref) {
    let {
      text,
      onClick
    } = _ref;
    const {
      actionLink
    } = this.props;
    return text && /*#__PURE__*/_jsx(Button, {
      href: actionLink,
      className: "".concat(namespace, "__action"),
      onClick: event => this.onActionClick(event, onClick),
      hierarchy: "transparent"
    }, void 0, text);
  }
  render() {
    var _window;
    const {
      action,
      actionMessage,
      actionPosition,
      className,
      color,
      children,
      message,
      onActionClick,
      type
    } = this.props;
    const {
      display,
      show,
      srLabelVisibility
    } = this.state;
    const computedAction = computeAction({
      action,
      actionMessage,
      onActionClick,
      actionPosition
    });
    const computedColor = computeTypeColor$1({
      type,
      color
    });
    const containerClassNames = classNames(namespace, className, "".concat(namespace, "--").concat(computedAction.position), {
      ["".concat(namespace, "--").concat(computedColor)]: computedColor,
      ["".concat(namespace, "--with-action")]: computedAction || children,
      ["".concat(namespace, "--animate-show")]: show,
      ["".concat(namespace, "--animate-hide")]: show === false
    });
    const isReduced = typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia('(prefers-reduced-motion: reduce)').matches) === true;
    if (!display || show === null || isReduced && show === false) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: containerClassNames,
      onAnimationEnd: this.onAnimationEnd,
      role: "presentation",
      ref: this.setMainContainerRef,
      style: this.style
    }, /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(VisuallyHidden, {
      role: "alert",
      "aria-live": "assertive"
    }, void 0, srLabelVisibility && message), /*#__PURE__*/_jsx("p", {
      className: "".concat(namespace, "__message")
    }, void 0, message), children && /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__children")
    }, void 0, children)), this.renderAction(computedAction));
  }
}
Snackbar.displayName = 'Snackbar';
var Snackbar$1 = Snackbar;
const {
  forwardRef
} = React;
const SnackbarContainer = forwardRef((props, ref) => /*#__PURE__*/
React.createElement(Snackbar$1, _extends({
  innerRef: ref
}, props)));
SnackbarContainer.displayName = 'Snackbar';
var SnackbarContainer$1 = SnackbarContainer;
export { SnackbarContainer$1 as Snackbar, SnackbarContainer$1 as default };
